/*
  Previous limited seasonal editions — keep the roll full on very wide screens.

  snippets/archive-marquee.liquid renders the edition list exactly twice and the CSS
  animates the track by -50%, which lands on the start of the second copy and makes the
  loop seamless. That holds only while one pass is at least as wide as the viewport.

  With nine editions a pass is 9 x 276px = 2484px (220px tile + 28px margin each side),
  so on anything wider than about 2484px the track runs out mid-cycle and the right-hand
  side of the band falls to empty grey. Nina hit this on an ultrawide monitor.

  Fix: repeat the pass until one pass is at least a viewport wide, always keeping an even
  number of passes so the track is exactly two identical halves and -50% still lands on a
  repeat. The duration is scaled by the same factor, so the bottles keep travelling at the
  speed set in the theme editor instead of speeding up as copies are added.

  Left alone when the CSS has switched the animation off, which is what the mobile
  breakpoint does when it turns the band into a horizontally scrollable row.
*/
(function () {
  'use strict';

  var SPEED_ATTR = 'data-roll-seconds';

  function passesNeeded(basePassWidth, viewport) {
    if (!basePassWidth) return 1;
    return Math.max(1, Math.ceil(viewport / basePassWidth));
  }

  function setup(marquee) {
    var track = marquee.querySelector('.archive-marquee__track');
    if (!track) return;

    if (getComputedStyle(track).animationName === 'none') return;

    var state = track.__archiveRoll;
    if (!state) {
      var children = Array.prototype.slice.call(track.children);
      if (children.length < 2) return;

      // The server always renders two identical passes, so the first half is the original.
      var half = children.length / 2;
      state = {
        base: children.slice(0, half).map(function (node) { return node.cloneNode(true); }),
        basePassWidth: track.scrollWidth / 2,
        seconds: parseFloat(track.getAttribute(SPEED_ATTR)) || 60,
        copies: 1
      };
      track.__archiveRoll = state;
    }

    var want = passesNeeded(state.basePassWidth, window.innerWidth);
    if (want === state.copies) return;

    var frag = document.createDocumentFragment();
    for (var pass = 0; pass < want * 2; pass++) {
      for (var i = 0; i < state.base.length; i++) {
        var node = state.base[i].cloneNode(true);
        // The row is announced once. Every repeat after the first is decoration.
        if (pass > 0) {
          node.setAttribute('aria-hidden', 'true');
          node.setAttribute('tabindex', '-1');
        } else {
          node.removeAttribute('aria-hidden');
          node.removeAttribute('tabindex');
        }
        frag.appendChild(node);
      }
    }

    track.textContent = '';
    track.appendChild(frag);
    // One cycle now covers `want` passes, so it needs `want` times the seconds to keep
    // the same pixels-per-second the editor setting asked for.
    track.style.animationDuration = state.seconds * want + 's';
    state.copies = want;
  }

  function run() {
    var marquees = document.querySelectorAll('.archive-marquee');
    for (var i = 0; i < marquees.length; i++) setup(marquees[i]);
  }

  var resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(run, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.addEventListener('resize', onResize);
  // The theme editor re-renders sections in place; re-fit when this one comes back.
  document.addEventListener('shopify:section:load', run);
})();
